import { Component, Prop, Vue } from 'types-vue'

@Component
export default class ValidationErrorList extends Vue {
  
  @Prop({required: true, type: Array }) protected validationErrors: string[]

}